import {
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { Modal } from 'flowbite';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-modal-create-backup',
  templateUrl: './modal-create-backup.html',
  styleUrl: './modal-create-backup.scss',
  standalone: false,
})
export class ModalCreateBackupComponent {
  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly clientId = input<number | undefined>();
  readonly assignedDriver = input<{ value: any; label: string }[]>([]);
  readonly assignedVehicle = input<{ value: any; label: string }[]>([]);
  driverSelected = model<any>();
  vehicleSelected = model<any>();
  commentSelected = model<string>();
  readonly action = output<any>();
  readonly creating = input<boolean>();

  public images = images;

  assignedDriverOption() {
    return this.assignedDriver() ?? [];
  }

  assignedVehicleOption() {
    return this.assignedVehicle() ?? [];
  }

  public optionsBus: AnimationOptions = {
    path: '/assets/animations/bus.json',
  };

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
  ) {}

  changeDriver(event: any) {
    this.driverSelected.set(event.value);
  }

  changeVehicle(event: any) {
    this.vehicleSelected.set(event.value);
  }

  changeComment(event: any) {
    this.commentSelected.set((event.target as HTMLTextAreaElement).value);
  }

  onSubmit() {
    if (!this.driverSelected() || !this.vehicleSelected()) return;
    this.action.emit({
      driverSelected: this.driverSelected(),
      vehicleSelected: this.vehicleSelected(),
      comment: this.commentSelected(),
    });
    this.vehicleSelected.set(undefined);
    this.driverSelected.set(undefined);
    this.commentSelected.set(undefined);
  }
}
